import React from 'react';
import './Intro.css';

const Intro: React.FC = () => {
  return (
    <section className="intro-section">
      <div className="container">
        <h2>Your Trusted Partner in Notarization</h2>
        <p>
          We provide reliable, fast, and professional notary services designed to meet your needs—whether online or in-person. 
          From document notarization to immigration forms and corporate resolutions, we ensure every process is simple and stress-free.
        </p>
      </div>
    </section>
  );
};

export default Intro;